import store from '@/store'

export function touchActivity() {
  window.dispatchEvent(new Event('mousemove'))
  store.commit('idleVue/IDLE_CHANGED', false)
}

export function beginPatientUpload() {
  touchActivity()
  store.commit('app/beginPatientUpload')
}

export function trackPatientUpload(uploadId: string, total: number) {
  touchActivity()
  store.commit('app/trackPatientUpload', { uploadId, total })
}

export function releasePatientUpload() {
  touchActivity()
  store.commit('app/finishPatientUpload')
}
